import { useSearchParams } from 'react-router-dom';

export default function useQualificationTab(defaultTab, allowed) {
  const [search, setSearch] = useSearchParams();
  const tab = allowed.includes(search.get('tab')) ? search.get('tab') : defaultTab;
  const rawId = search.get('request_id') || '';
  const focusRequestId = /^[1-9]\d{0,9}$/.test(rawId) ? Number(rawId) : null;
  const setTab = next => {
    const params = new URLSearchParams(search);
    params.set('tab', next); params.delete('request_id');
    setSearch(params);
  };
  const rawCompany = search.get('company_id') || '';
  const companyId = /^[1-9]\d{0,9}$/.test(rawCompany) ? rawCompany : '';
  return { tab, setTab, focusRequestId, companyId };
}
